document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.nav-general');
  if (header) {
    const updateHeader = () => header.classList.toggle('nav-active', window.scrollY > 0);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const trigger = document.querySelector('#abrir-menu');
  const mobileMenu = document.querySelector('#menuMobile');
  if (trigger && mobileMenu) {
    trigger.addEventListener('click', () => {
      const active = mobileMenu.classList.toggle('menumob-active');
      trigger.setAttribute('aria-expanded', String(active));
    });
  }
});
